<script lang="ts">
	import type { OperationModel } from '@app/models/api/OperationModel';
	import ProjectDescription from '@app/components/projects/elements/ProjectDescription.svelte';
	import ProjectPhotoGallery from '@app/components/projects/elements/ProjectPhotoGallery.svelte';
	import ProjectVision from '@app/components/projects/elements/ProjectVision.svelte';
	import ProjectTeam from '@app/components/projects/elements/ProjectTeam.svelte';
	import ProjectScoringESG from '@app/components/projects/elements/ProjectScoringESG.svelte';
	import ProjectAnalysis from '@app/components/projects/elements/ProjectAnalysis.svelte';
	import ProjectDevelopmentSteps from '@app/components/projects/elements/ProjectDevelopmentSteps.svelte';
	import ProjectFundUsage from '@app/components/projects/elements/ProjectFundUsage.svelte';
	import ProjectSocialNetwork from '@app/components/projects/elements/ProjectSocialNetwork.svelte';
	import ProjectProofOfTransparency from '@app/components/projects/elements/ProjectProofOfTransparency.svelte';
	import ProjectOutingsStrategy from '@app/components/projects/elements/ProjectOutingsStrategy.svelte';
	import { OperationStatusEnum } from '@app/models/api/enums/OperationStatusEnum.js';
	import { OperationFinancialInstrumentEnum } from '@app/models/api/enums/OperationFinancialInstrumentEnum.js';
	import RealEstatePerformanceSimulator from '@app/components/projects/elements/real-estate/RealEstatePerformanceSimulator.svelte';

	export let operation: OperationModel;
</script>

<ProjectDescription {operation} />
<ProjectPhotoGallery {operation} />
<ProjectVision {operation} />
<ProjectTeam {operation} />
<ProjectScoringESG {operation} />
<ProjectAnalysis {operation} />
<ProjectDevelopmentSteps {operation} />
{#if operation.status?.includes(OperationStatusEnum.FUNDING) && !operation.clotureEnCours && operation.financialInstrument === OperationFinancialInstrumentEnum.BONDS && !operation.isVariableRate}
	<RealEstatePerformanceSimulator {operation} />
{/if}
<ProjectOutingsStrategy {operation} />
<ProjectFundUsage {operation} />
<div class="space-y-1">
	<ProjectSocialNetwork {operation} />
	<ProjectProofOfTransparency {operation} />
</div>
